import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import axiosInstance from "../api/axios";
import PetLoader from "./Petloader.js";

const SubscriptionProtectedRoute = ({ element }) => {
  const { isAuthenticated } = useAuth();
  const [hasActiveSubscriptions, setHasActiveSubscriptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loaderMessage, setLoaderMessage] = useState(
    "Checking your subscription...",
  );

  useEffect(() => {
    const checkActiveSubscriptions = async () => {
      if (!isAuthenticated) {
        setHasActiveSubscriptions(false);
        setLoading(false);
        return;
      }

      // Bulk/partner users bypass Stripe entirely
      const isBulk       = localStorage.getItem("bulkAccess") === "true";
      const bulkStatus   = localStorage.getItem("bulkAccessStatus") || "active";

      if (isBulk) {
        setHasActiveSubscriptions(bulkStatus === "active");
        setLoading(false);
        return;
      }

      // Regular Stripe subscription check
      const messages = [
        { text: "Checking your subscription...", delay: 0 },
        { text: "Waking up the server... 🐾", delay: 5000 },
        { text: "Almost there...", delay: 15000 },
        { text: "Just a few more seconds...", delay: 28000 },
      ];
      const timers = messages.map(({ text, delay }) =>
        setTimeout(() => setLoaderMessage(text), delay),
      );

      try {
        const userEmail = localStorage.getItem("userEmail");
        if (!userEmail) throw new Error("User not logged in.");

        const response = await axiosInstance.get(
          `/subscriptions?email=${userEmail}`,
        );
        const subscriptions = response.data.subscriptions?.data || [];
        const activeSubscription = subscriptions.some(
          (sub) => sub.status === "active" || sub.status === "trialing",
        );

        setHasActiveSubscriptions(activeSubscription);
      } catch (error) {
        console.error("Error checking subscriptions:", error);
        setHasActiveSubscriptions(false);
      } finally {
        timers.forEach(clearTimeout);
        setLoading(false);
      }
    };

    checkActiveSubscriptions();
  }, [isAuthenticated]);

  if (loading) {
    return <PetLoader isVisible={true} message={loaderMessage} />;
  }

  if (!isAuthenticated || !hasActiveSubscriptions) {
    return <Navigate to="/account" />;
  }

  return element;
};

export default SubscriptionProtectedRoute;
